import React from 'react'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import cn from 'classnames'

import styles from './styles.module.scss'

import { CalendarIcon } from '../Icons'

const AssetTimeLeft = ({ rentalEndDate }) => {
  const { t } = useTranslation()

  const diff = moment(rentalEndDate).diff(moment(), 'days')

  return (
    <div className={cn(styles.container, {[styles.danger]: diff <= 0, [styles.warning]: diff > 0 && diff <= 3})}>
      <CalendarIcon />
      {
        !rentalEndDate
          ? t('No deadline')
          : diff > 0
            ? t('Return in {{days}} days', { days: diff })
            : t('{{days}} days overdue', { days: -diff })}
        
    </div>
  )
}

export default AssetTimeLeft